import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import apiClient from '../api/client'

function RequireAdmin(): JSX.Element {
  const [checked, setChecked] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    apiClient
      .get<{ role: string }>('/auth/me')
      .then((res) => {
        const data = res.data as { role: string }
        setIsAdmin(data.role === 'admin')
        setChecked(true)
      })
      .catch(() => {
        setChecked(true)
        setIsAdmin(false)
      })
  }, [])

  if (!checked) return <div style={{ padding: 24 }}>Checking admin access...</div>
  if (!isAdmin) return <Navigate to="/dashboard" replace />
  return <Outlet />
}

export default RequireAdmin
